export default __webpack_public_path__ + "5b08afd6b167d7ec48ce49c69262dea1.woff";